module.exports = __webpack_public_path__ + "img/Führungsgruppe_Feuerwehrbereitschaft.9959f77f.svg";